import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { storage } from "config/firebase";
import { ref, uploadBytes, getDownloadURL } from "@firebase/storage";
import { Attachment } from "@freetech/models";

export const updateBugReportAttachments = async (
  bugReportId: string,
  files: File[]
): Promise<void> => {
  try {
    const bugReportRef = doc(db, "bugReports", bugReportId);


    const bugReportDoc = await getDoc(bugReportRef);
    const currentAttachments = bugReportDoc.data()?.attachments || [];


    const uploadPromises = files.map(async (file) => {
      const storageRef = ref(storage, `bugReports/${bugReportId}/${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      return {
        id: `${bugReportId}_${file.name}`,
        name: file.name,
        url,
        uploadedAt: new Date().toISOString(),
      } as Attachment;
    });

    const newAttachments = await Promise.all(uploadPromises);


    const allAttachments = [...currentAttachments, ...newAttachments];


    await updateDoc(bugReportRef, {
      attachments: allAttachments,
      updatedAt: new Date(),
    });
  } catch (error) {
    console.error("Error updating attachments:", error);
  }
};
